import { fetchSimDocumentsToken } from "../../authentication/AuthenticationHelper";
import axios from "axios";

interface DeleteDocumentParams {
    documentReference: string,
    reason: string
}

export const DeleteDocumentAsync = async ({
    documentReference,
    reason, 
}: DeleteDocumentParams) => {
    const token = await fetchSimDocumentsToken();
    
    const config = {
        headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Reason: reason
        }
    };

    await axios.delete(
        `${process.env.REACT_APP_SIM_DOCUMENTS_BASE_URL}/v1/SIMDocuments/Documents/${documentReference}`,
        config
    );
}